var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.title,"center":"","visible":_vm.show,"before-close":_vm.handleClose,"custom-class":_vm.customClass,"close-on-click-modal":_vm.closeOnClickModal,"close-on-press-escap":_vm.closeOnPressEscap,"show-close":_vm.showClose},on:{"update:visible":function($event){_vm.show=$event}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }